import { Injectable, Inject } from '@angular/core';
import { ChangePassword } from '../models/change-password.model';
import { SecurityQuestionAnswer } from '../models/security-question-answer.model';
import { SecurityQuestion } from '../models/security-question.model';
import { HhsgSharedUserProfile } from '../models/user-profile.model';
import { HhsgSharedConfigService } from './config.service';
import { HhsgSharedHttpService } from './http.service';

@Injectable({
  providedIn: 'root'
})
export class HhsgSharedProfileService {
  private _controllerName: string = 'profile';
  private apiServer: string;

  constructor(private _serviceUtil: HhsgSharedHttpService, _configServer: HhsgSharedConfigService) {
    this.apiServer = _configServer.appSettings.stsServer;
  }

  async changePassword(changePassword: ChangePassword): Promise<any> {
    return this._serviceUtil.doPostRequestAsync(this.apiServer, this._controllerName, 'ChangePassword', changePassword);
  }

  async getUserProfileData(): Promise<any> {
    return this._serviceUtil.doGetRequestAsync(this.apiServer, this._controllerName, 'GetUserProfileData')
    .then((userProfileData: any) => {
      const userProfile = <HhsgSharedUserProfile>{
        userApplications: userProfileData.userApplications,
        isSsoUser: userProfileData.loginMethod.length && userProfileData.loginMethod !== 'None',
        brandingImage: userProfileData.brandingImage,
        brandingName: userProfileData.brandingName
      };
      return userProfile;
    });
  }

  async getSecurityQuestions(): Promise<SecurityQuestion[]> {
    return this._serviceUtil.doGetRequestAsync<SecurityQuestion[]>(this.apiServer, this._controllerName, 'GetSecurityQuestions');
  }

  async getExistingUserSecurityQuestions(): Promise<SecurityQuestionAnswer[]> {
    return this._serviceUtil.doGetRequestAsync<SecurityQuestionAnswer[]>(this.apiServer, this._controllerName, 'GetExistingUserSecurityQuestions');
  }

  async getPasswordRecoveryAnswersCount(): Promise<number> {
    return this._serviceUtil.doGetRequestAsync<number>(this.apiServer, this._controllerName, 'GetPasswordRecoveryAnswersCount');
  }

  async saveSecurityQuestions(answers: SecurityQuestionAnswer[]): Promise<any> {
    return this._serviceUtil.doPostRequestAsync(this.apiServer, 'PasswordRecovery', 'Save', answers);
  }

  async getNotifications(userid: number): Promise<void | Notification[]> {
    return this._serviceUtil.doPostRequestAsync<any, Notification[]>(this.apiServer, this._controllerName, 'GetNotifications', userid);
  }
}

@Injectable()
export class HhsgSharedMockProfileService {
  answers: SecurityQuestionAnswer[] = [<SecurityQuestionAnswer>{
    userId: 0,
    questionId: 0,
    answerText: "The freezer"
  }]

  constructor(@Inject('MockUser') private mockUser: any) { }

  async changePassword(changePassword: ChangePassword): Promise < any > {
    return Promise.resolve(true);
  }

  async getUserProfileData(): Promise < any > {
    return Promise.resolve(this.mockUser);
  }

  async getSecurityQuestions(): Promise < SecurityQuestion[] > {
    return Promise.resolve([<SecurityQuestion>{
      id: 0,
      questionText: "Where's the beef?"
    }]);
  }

  async getExistingUserSecurityQuestions(): Promise < SecurityQuestionAnswer[] > {
    return Promise.resolve(this.answers);
  }

  async getPasswordRecoveryAnswersCount(): Promise < number > {
    return Promise.resolve(0);
  }

  async saveSecurityQuestions(answers: SecurityQuestionAnswer[]): Promise < any > {
    this.answers = answers;
    return Promise.resolve(answers);
  }

  async getNotifications(userid: number): Promise < void | Notification[] > {
    return Promise.resolve(null);
  }
}
